import { createContext, useContext } from 'react';
import { TSession } from '@/features/auth/schemas/auth.schema.ts';

export type SessionContextType = TSession & {
  isLoading: boolean;
  isAuthenticated: boolean;
  expiresAt: number | undefined;
  logOut: () => void;
};

export const SessionContext = createContext<SessionContextType | null>(null);

export const useSession = (): SessionContextType => {
  const context = useContext(SessionContext);
  if (context === null) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return context;
};
